import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import NumberInputIntroduction from "../UI elements/NumberInput";
import SimpleDatepicker from "../UI elements/Datepicker";
import TextEditor from "../UI elements/TextEditor";
import IOSSwitch from "../UI elements/iOSswitch";
import axiosInstance from "../../../../../axiosInstance";

const Settings = (props) => {
  const [ChangesMade, setChangesMade] = useState(false);
  const [TermsHTML, setTermsHTML] = useState();
  const [Settings, setSettings] = useState({});
  const [TermsSettingId, setTermsSettingId] = useState();

  useEffect(() => {
    fetchSettings();
    fetchTermsAndConditions();
  }, []);

  const fetchTermsAndConditions = () => {
    let Req = {
      method: "GET",
      baseURL: window.localStorage.getItem("BaseURL") + "/api/legal-infos",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        console.log(Res);
        let TermsData = Res.data.filter((Item) => {
          return Item.type === "TERMS_AND_CONDITIONS";
        });
        setTermsHTML(TermsData[0].content);
        setTermsSettingId(TermsData[0].id);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchSettings = () => {
    let Req = {
      method: "GET",
      baseURL: window.localStorage.getItem("BaseURL") + "/api/system-settings",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        console.log(Res);
        setSettings(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const saveTermsText = (html) => {
    setChangesMade(true);
    setTermsHTML(html);
  };

  const handleSwitchChange = (e) => {
    setChangesMade(true);
    setSettings({ ...Settings, allowRegistration: e.target.checked });
  };

  const handleCreditsChange = (Value) => {
    setChangesMade(true);
    setSettings({
      ...Settings,
      creditsForNewUser: Value,
    });
  };

  const saveBasicSettings = () => {
    let Req = {
      method: "PATCH",
      baseURL:
        window.localStorage.getItem("BaseURL") +
        "/api/system-settings/" +
        Settings.id,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: Settings,
    };
    axiosInstance(Req)
      .then((Res) => {
        console.log(Res);

        // after successful save, saving the terms and conditions
        saveTermsAndConditions();
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const saveTermsAndConditions = () => {
    let Req = {
      method: "PATCH",
      baseURL:
        window.localStorage.getItem("BaseURL") +
        "/api/legal-infos/" +
        TermsSettingId,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        id: TermsSettingId,
        content: TermsHTML,
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        console.log(Res);
        setChangesMade(false);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const saveData = () => {
    saveBasicSettings();
  };

  return (
    <div className="form-wrapper admin-panel-settings">
      <section className="form-head">
        <h1 className="head-title" style={{ left: "24px" }}>
          Settings
        </h1>
        <section className="head-actions">
          <span className="action-btn cancel">
            <Link to="/Home">Cancel</Link>
          </span>
          <span
            className={
              ChangesMade ? "action-btn save" : "action-btn save disabled"
            }
            onClick={() => saveData()}
          >
            Save
          </span>
        </section>
      </section>
      <div className="table-body">
        <section
          className="top-section"
          style={{ borderBottom: "none", marginBottom: "0" }}
        >
          <p className="section-label">Subscriptions</p>
          <section className="section-row">
            <p className="row-name">New Registration</p>
            {Settings.allowRegistration !== undefined ? (
              <>
                <IOSSwitch
                  checked={Settings.allowRegistration ? true : false}
                  onChange={handleSwitchChange}
                />
              </>
            ) : null}
          </section>
          <section className="section-row">
            <p className="row-name">New user free credits</p>
            <NumberInputIntroduction
              OnChange={(e) => handleCreditsChange(e)}
              CustomWidth={"190px"}
              Value={parseInt(Settings.creditsForNewUser)}
            />
          </section>
          <section className="section-row disabled">
            <p className="row-name">System maintenance</p>
            <div className="datepicker-wrapper">
              <SimpleDatepicker
                Label={"Date"}
                CustomWidth={"200px"}
                Disabled
                DefaultValue={new Date()}
              />
              <p className="hint">MM/DD/YYYY</p>
            </div>
          </section>
        </section>
        <section
          className="top-section"
          style={{ borderBottom: "none", marginTop: "-32px" }}
        >
          <p className="section-label">Terms, Payment and Data Privacy</p>
          {TermsHTML ? (
            <TextEditor
              SaveTextEditorValue={(html) => saveTermsText(html)}
              Value={TermsHTML}
            />
          ) : null}
        </section>
      </div>
    </div>
  );
};

export default Settings;
